import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'data'
})
export class DataPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return "";

    return moment(value, 'YYYY-MM-DD').format("DD/MM/YYYY");
  }

}
